import { Cirus } from "@/classes/Http";
export enum PaymentMethodEnums {
    tayeh='tayeh',
    manual='manual'
}
export function setInstancePaymentMethod(instance_id: number, method_id: PaymentMethodEnums, active: boolean) {
    const path = `/instance/${instance_id}/payment-methods`;
    return Cirus.post(path, {
        id: method_id,
        active
    });
}